import React, {useCallback, useContext, useEffect, useMemo} from 'react';
import Rule from './Rule';
import {emptyStateNew, plusBlue} from 'assets/images/images';
import {ChevronsLeft} from 'lucide-react';
import {addNewRule, deleteRule} from '../hooks/ruleUtils';
import {useFlowData} from '../../EditProcess/hooks/useFlowData';
import {CreditCheckContext} from '../../../../../helpers/context/CreditCheckContext';
import {PrimaryButton} from 'components';
import {findParentByChild} from '../../EditProcess/utils';
import {EasyDetectContext} from '../../../../../helpers/context/EasyDetectContext';

function RuleEditor({isOpen, toggleEditor, rules, setRules}) {
  const {
    set: {setCurrentActiveRule},
    get: {currentActiveRule},
  } = useContext(CreditCheckContext);
  const {aggregateFunction, isAggregateFunction} =
    useContext(EasyDetectContext);
  const handleAddNewRule = useCallback(() => {
    addNewRule(rules, setRules, undefined, setCurrentActiveRule);
  }, [rules, setRules, setCurrentActiveRule]);
  const FLowData = useFlowData();
  const availableFields = React.useMemo(() => {
    if (FLowData.fieldsAndOperators) {
      return FLowData.fieldsAndOperators.data;
    }
  }, [FLowData.fieldsAndOperators]);

  const findParentFields = useCallback(
    childValue => findParentByChild(childValue, availableFields),
    [availableFields],
  );

  useEffect(() => {
    const currentRules = [...rules];
    currentRules.map(rule => {
      if (isAggregateFunction) {
        rule.event ||= {};
        rule.event.params ||= {};
        rule.event.params.period ||= aggregateFunction;
        rule.event.params.period_minutes ||= 30;
      }

      if (Array.isArray(rule.groups)) {
        rule.groups.forEach(group => {
          group.conditions.forEach(condition => {
            if (condition.field) {
              const parentField = findParentFields(
                condition.field.replace(/_last.*$/, ''),
              )?.value;
              if (parentField === 'aggregate_functions') {
                const currentPeriod =
                  rule.event?.params?.period || aggregateFunction;
                condition.field = `${condition.field.replace(
                  /_last.*$/,
                  '',
                )}_${currentPeriod}`;
              }
            }
          });
        });
      }
    });
    setRules(currentRules);
    // eslint-disable-next-line
  }, [aggregateFunction, isAggregateFunction, findParentFields]);

  const handleDeleteRule = ruleId => {
    deleteRule(rules, setRules, ruleId);
    setCurrentActiveRule({});
  };

  const activeRule = useMemo(
    () => rules.find(rule => rule.id === currentActiveRule.id),
    [currentActiveRule.id, rules],
  );

  return (
    <div className="relative">
      <aside
        className={`bg-white w-[394px] py-3 transition-all duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{
          position: 'absolute',
          zIndex: 10,
          height: 'calc(100vh - 120px)',
          overflowY: 'auto',
        }}
      >
        <div className="flex items-center justify-between relative pr-10 mb-3">
          <p className="text-[#080917] text-base font-medium pl-4">
            Rule editor
          </p>

          <button
            onClick={handleAddNewRule}
            className="flex items-center text-sm font-medium h-10 px-4 py-2 border rounded-md text-[#033971] border-[#DFE1E7] hover:bg-grey-50"
          >
            <img src={plusBlue} alt="Add" className="mr-2" />
            Add New Rule
          </button>
        </div>

        {/*{rules.map(rule => (*/}
        {/*  <Rule*/}
        {/*    key={rule.id}*/}
        {/*    rule={rule}*/}
        {/*    rules={rules}*/}
        {/*    setRules={setRules}*/}
        {/*    onDelete={async () => {*/}
        {/*      if (rule.ruleId) {*/}
        {/*        await FLowData.deleteRule(rule.ruleId);*/}
        {/*      }*/}
        {/*      handleDeleteRule(rule.id);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*))}*/}

        {activeRule?.id ? (
          <Rule
            key={activeRule.id}
            rule={activeRule}
            rules={rules}
            setRules={setRules}
            onDelete={async () => {
              if (activeRule.ruleId) {
                await FLowData.deleteRule(activeRule.ruleId);
              }
              handleDeleteRule(activeRule.id);
            }}
          />
        ) : (
          <div className="mt-20 flex flex-col px-16 gap-3 justify-center items-center">
            <img
              src={emptyStateNew}
              className="w-[68px] h-[68px]"
              alt="Empty state Image"
            />
            <p className="text-[11px] text-body text-center">
              Click the button below to add rule or click an existing rule on
              the canvas to edit
            </p>
            <PrimaryButton
              onClick={handleAddNewRule}
              buttonText="Add a New Rule"
              className="w-[120px] h-[30px] !text-[10px]"
            />
          </div>
        )}
      </aside>

      <button
        onClick={toggleEditor}
        className={`rounded-full border border-[#DFE1E7] p-2 absolute bg-white transition-all duration-300 z-20 ${
          isOpen ? 'left-[370px]' : 'left-[16px] rotate-180'
        }`}
        style={{top: '10px'}}
      >
        <div className="flex items-center bg-brandBlue justify-center rounded-full text-white w-5 h-5">
          <ChevronsLeft size={14} />
        </div>
      </button>
    </div>
  );
}

export default RuleEditor;
